import { Route } from "react-router-dom";
import { _adr } from "../address";
import { Roles } from "../tools/services";
import { ProtectedRoute } from "../tools/protectedRoute";
import CSValidMsisdn from "../components/changeSimCard/change/valid";
import CSNewKit from "../components/changeSimCard/change/kit/newKit";
import CSPrefactor from "../components/changeSimCard/change/prefactor/csprefactor";
import CSDocument from "../components/changeSimCard/change/document/csDocument";
import CSFinalFactor from "../components/changeSimCard/change/final/csfinal";
import CSReport from "../components/changeSimCard/reports/report-list/cs-report";
import CSListPendingDocument from "../components/changeSimCard/pending/list/csListPendingDocument";
import CSPendingDocument from "../components/changeSimCard/pending/document/csPendingDocument";

export const simCardReplacementRoutes = [
	// تعویض سیم‌کارت
	<Route
		key="cs-valid-msisdn"
		path={_adr.Root + _adr.SimCardReplacement.Index + _adr.SimCardReplacement.Replacement + _adr.SimCardReplacement.ValidMsisdn}
		element={<ProtectedRoute role={Roles.Dealer_SimSwap_B2C_Iranian} element={CSValidMsisdn} />}
	/>,
	<Route
		key="cs-valid-kit"
		path={_adr.Root + _adr.SimCardReplacement.Index + _adr.SimCardReplacement.Replacement + _adr.SimCardReplacement.ValidKit}
		element={<ProtectedRoute role={Roles.Dealer_SimSwap_B2C_Iranian} element={CSNewKit} />}
	/>,
	<Route
		key="cs-prefactor"
		path={_adr.Root + _adr.SimCardReplacement.Index + _adr.SimCardReplacement.Replacement + _adr.SimCardReplacement.PreFactor}
		element={<ProtectedRoute role={Roles.Dealer_SimSwap_B2C_Iranian} element={CSPrefactor} />}
	/>,
	<Route
		key="cs-document"
		path={_adr.Root + _adr.SimCardReplacement.Index + _adr.SimCardReplacement.Replacement + _adr.SimCardReplacement.Document}
		element={<ProtectedRoute role={Roles.Dealer_SimSwap_B2C_Iranian} element={CSDocument} />}
	/>,
	<Route
		key="cs-final"
		path={_adr.Root + _adr.SimCardReplacement.Index + _adr.SimCardReplacement.Replacement + _adr.SimCardReplacement.Final}
		element={<ProtectedRoute role={Roles.Dealer_SimSwap_B2C_Iranian} element={CSFinalFactor} />}
	/>,

	// گزارش تعویض سیم‌کارت
	<Route
		key="cs-report"
		path={_adr.Root + _adr.SimCardReplacement.Index + _adr.SimCardReplacement.Report.Index + _adr.SimCardReplacement.Report.List}
		element={<ProtectedRoute role={Roles.Dealer_SimSwap_Report_One} element={CSReport} />}
	/>,

	// در انتظار آپلود مدارک
	<Route
		key="cs-pending-list"
		path={_adr.Root + _adr.SimCardReplacement.Index + _adr.SimCardReplacement.Pending.Index + _adr.SimCardReplacement.Pending.List}
		element={<ProtectedRoute role={Roles.Dealer_SimSwap_Report_UploadingDoc} element={CSListPendingDocument} />}
	/>,
	<Route
		key="cs-pending-upload"
		path={_adr.Root + _adr.SimCardReplacement.Index + _adr.SimCardReplacement.Pending.Index + _adr.SimCardReplacement.Pending.upload}
		element={<ProtectedRoute role={Roles.Dealer_SimSwap_Report_UploadingDoc} element={CSPendingDocument} />}
	/>,
];
